import { render, staticRenderFns } from "./portifolio.vue?vue&type=template&id=5125f0a2&scoped=true&"
import script from "./portifolio.vue?vue&type=script&lang=js&"
export * from "./portifolio.vue?vue&type=script&lang=js&"
import style0 from "./portifolio.vue?vue&type=style&index=0&id=5125f0a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5125f0a2",
  null
  
)

export default component.exports